<div class="profile">
  <app-profile-toolbar
    [selectedTab]="selectedTab()"
    [showSubscriptions]="showSubscriptions()"
    (tabChange)="onTabChange($event)"
  />

  <div class="profile__content">
    @switch (selectedTab()) {
      @case ('general') {
        <app-personal-info [user]="user()" />
      }
      @case ('settings') {
        <app-settings />
      }
      @case ('subscriptions') {
        <app-subscriptions [user]="user()" />
      }
    }
  </div>

  <footer class="profile__footer">
    <app-parent-button variant="text-ghost" [spread]="true" (clicked)="logout()">
      {{ 'app.components.profile.logout' | translate }}
      <img src="/public/svgs/logout.svg" alt="" width="16" height="16" aria-hidden="true" />
    </app-parent-button>

    <app-parent-button variant="text-danger" [spread]="true" [disabled]="true">
      {{ 'app.components.profile.deleteAccount' | translate }}
      <img src="/public/svgs/trash-red.svg" alt="" width="16" height="16" aria-hidden="true" />
    </app-parent-button>
  </footer>
</div>
